import React, { Fragment, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FetchContext from "../../../contexts/fetch";
import FlowContext from "../../../contexts/flowContext";
import UserContext from "../../../contexts/user";

const UrlParameters = () => {
  const navigate = useNavigate();
  const params = useParams();

  const [userState, userDispatcher] = useContext(UserContext);
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [fetchState, fetchDispatcher] = useContext(FetchContext);

  useEffect(() => {
    // when component mounts, extract url params and set them in the flow context
    const { app, brand, flowName, version } = params;

    if (app !== flowState.app) {
      flowDispatcher({
        type: "update-flow-app",
        app,
      });
    }
    if (brand !== flowState.brand) {
      flowDispatcher({
        type: "update-flow-brand",
        brand,
      });
    }
    if (flowName) {
      flowDispatcher({
        type: "update-flow-name",
        name: flowName,
      });
    }
    if (version !== flowState.version) {
      flowDispatcher({
        type: "udpate-flow-version",
        version,
      });
    }
  }, []);

  // propagate changes (app, brand, flowName, version) from flowState to the url
  useEffect(() => {
    const { app, brand, flowName, version } = params;
    const {
      app: currentApp,
      brand: currentBrand,
      name: currentFlowName,
      version: currentVersion,
    } = flowState;

    if (currentApp && currentBrand && currentFlowName && currentVersion) {
      navigate(
        `../${currentApp}/${currentBrand}/${currentFlowName}/${currentVersion}`,
        {
          replace: true,
        }
      );
    }
  }, [
    userState.currentApp,
    userState.currentBrand,
    userState.currentFlowName,
    userState.currentVersion,
  ]);

  return <Fragment></Fragment>;
};

export default UrlParameters;
